// SPDX-License-Identifier: AGPL-3.0-or-later
import {ParserFlags} from '@app/vendor/markdown_parser/types/Enums';

export const TABLE_PARSING_ENABLED = true;
export const TABLE_PARSING_FLAG = ParserFlags.ALLOW_TABLES;
